// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jm-1";
export var messageSideRight = "_jm-2";
export var subscribeToBackInStockBubbleContainer = "_jm-0";